class PageController {

    /** @construct */
    constructor() {

        /** Get this page. */
        this.thePage = $("#page-home");
        this.thePageKey = this.thePage.attr("key");
    }

    /**
     * Retrieves a specific section in the current page.
     *
     * @param  {string} key Section key.
     *
     * @return {Object}     Section element, if found.
     */
    section(key) {

        /** Attempt to find the specified section. */
        let section = this.thePage.find('.section[key="'+key+'"]');
        return (section.length !== 0) ? section : false;
    }
}

// [PAGE] HOME
// ----------------------------------------

class HomePage extends PageController {

    /** @construct */
    constructor() {
        super();
        this.pageTitle = "Home";
    }

    // HERO
    // ----------------------------------------

    /** @setup: Slide. */
    setup__hero_slide() {
        let $inst = this;

        /** Get main elements. */
        let section = $inst.section("hero");
        let slide = section.find(".slide .slide-items");
        let navigation = section.find(".slide .slide-navigation");
        let next = section.find(".slide .slide-next");

        /** Activate the first dot. */
        navigation.find('.dot[data-index="0"]').addClass("active");

        /** Setup timeout for slide change. */
        $inst.hero__set_interval();

        /** Bind click event to the arrows. */
        navigation.find(".arrow").on("click", function() {
            if (slide.is(".is-changing")) return false;

            /** Get the direction. */
            let direction = $(this).data("direction");

            /** Change the active slide. */
            $inst.hero__change_slide(direction);
        })

        /** Bind click event to the next button. */
        next.find(".item .item-link").on("click", () => {
            if (slide.is(".is-changing")) return false;

            /** Change the active slide. */
            $inst.hero__change_slide("next");
        })

        /** Pause the interval while hovering hints. */
        slide.find(".is-hint")
            .on("mouseenter", () => $inst.hero__set_interval("off"))
            .on("mouseleave", () => $inst.hero__set_interval())
    }

    /** @setup: Hidden panels. */
    setup__hero_hidden_panels() {
        let $inst = this;

        /** Get main elements. */
        let section = $inst.section("hero");
        let slide_items = section.find(".slide .slide-items .item");

        /** Toggle panel opening on hover (in, out). */
        slide_items.find(".item-content .headline .headline-hint").each(function() {

            /** Get the current item. */
            let item = $(this).parents(".item");

            /** Bind hover event to this hint. */
            $(this)
                .on("mouseover", () => item.addClass("hidden-panel--open"))
                .on("mouseleave", () => item.removeClass("hidden-panel--open"))
        })
    }

    /** @setup: Hero hints transition. */
    setup__hero_hints_transition() {
        let $inst = this;

        /** Get main elements. */
        let section = $inst.section("hero");
        let hints = section.find(".slide .slide-items .item .item-hints");

        /** Activate the transition when hovering the hint. */
        hints.find(".hint")
            .on("mouseenter", function() {
                $(this).addClass("split-text-transition");
            })
            .on("mouseleave", function() {
                $(this).removeClass("split-text-transition");
            })
    }

    /** @action: Start interval for autoplay. */
    hero__set_interval(state="on") {
        let $inst = this;

        /** Get main elements. */
        let section = $inst.section("hero");
        let navigation = section.find(".slide .slide-navigation");

        /** Check for interval state. */
        if (state === "on") {

            /** Initiate the interval. */
            $inst.hero_slide_interval = setInterval(() => $inst.hero__change_slide("next"), 7000);

            /** Start the active dot animation. */
            navigation.find(".dot.active").addClass("is-animating");
        } else {

            /** Pause the interval. */
            clearInterval($inst.hero_slide_interval);

            /** Stop any active dots from animating. */
            navigation.find(".dot.active").removeClass("is-animating");
        }
    }

    /** @action: Change active slide. */
    hero__change_slide(direction) {
        let $inst = this;

        /** Reset interval. */
        $inst.hero__set_interval("off");
        $inst.hero__set_interval();

        /** Get main elements. */
        let section = $inst.section("hero");
        let slide = section.find(".slide .slide-items");
        let navigation = section.find(".slide .slide-navigation");
        let next = section.find(".slide .slide-next");

        /** Lock the slide. */
        slide.addClass("is-changing");

        /** Get the current slide. */
        let current_slide = slide.find(".item.active");
        let current_slide_index = current_slide.data("index");
        /** Get the next slide. */
        let next_slide_index = (direction === "prev") ? current_slide_index - 1 : current_slide_index + 1;
        if (next_slide_index < 0) next_slide_index = (slide.find(".item").length - 1);
        if (next_slide_index === slide.find(".item").length) next_slide_index = 0;
        let next_slide = slide.find('.item[data-index="'+next_slide_index+'"]');

        /** Change the active dot. */
        navigation.find(".dots .dot.active").removeClass("active is-animating");
        navigation.find('.dots .dot[data-index="'+next_slide_index+'"]').addClass("active is-animating");

        /** Change the current index display. */
        navigation.find(".index-current").text(("0"+(next_slide_index+1)).slice(-2));

        /** Change the active slide. */
        current_slide.removeClass("active");
        setTimeout(() => {
            next_slide.addClass("active");
            setTimeout(() => slide.removeClass("is-changing"), 1000);
        }, 1000);

        /** Get the [next] slide. */
        let next_index = next_slide_index + 1;
        if (next_index === slide.find(".item").length) next_index = 0;

        /** Change the active [next] slide. */
        next.addClass("is-changing");
        setTimeout(() => {
            next.find(".item.active").removeClass("active");
            next.find('.item[data-index="'+next_index+'"]').addClass("active");
            setTimeout(() => next.removeClass("is-changing"), 500);
        }, 500);
    }


    // INIT
    // ----------------------------------------

    init() {
        let $inst = this;

        /** Main setups. */
        $inst.setup__hero_slide();
        $inst.setup__hero_hidden_panels();
        $inst.setup__hero_hints_transition();


    }
}

// [PAGE] HOME MOBILE
// ----------------------------------------

class HomeMobilePage extends PageController {

    /** @construct */
    constructor() {
        super();
        this.pageTitle = "HomeMobile";
    }

    // HERO
    // ----------------------------------------

    /** @setup: Slide. */
    setup__hero_slide() {
        let $inst = this;

        /** Get main elements. */
        let section = $inst.section("hero");
        let slide = section.find(".slide .slide-items");

        /** Setup slick. */
        slide.slick({
            arrows: false,
            dots: true,
            speed: 700,
            fade: true,
            autoplay: true,
            autoplaySpeed: 4000
        })
    }

    // INIT
    // ----------------------------------------

    init() {
        let $inst = this;

        /** Main setups. */
        $inst.setup__hero_slide();
    }
}

$(document).ready(function (){
    // MAIN ACTION
// ----------------------------------------

    /**
     * Pages list.
     * @type {Object}
     */
    const pages_list = {
        home: HomePage,
        home_mobile: HomeMobilePage

    }
    /** @inst: Page controller. */
    const pageCtrl = new PageController();
    /** Check for page controller. */
    if (typeof pages_list[pageCtrl.thePageKey] !== "undefined") {

        /** Create a new instance for the current page. */
        const Page = new pages_list[pageCtrl.thePageKey];

        /** [LOG] */
        //console.log('Page {{ '+Page.pageTitle+' }} is initializing...', "default");

        /** @init */
        Page.init();
    } else {
        //console.log("No controller declared for this page.", "info", "ctrl");
    }

});
